import useDefaultChartOptions from '@/components/charts/composables/useDefaultChartOptions';

export default function useColumnChartOptions(chartInstanceOptions: any) {
    return useDefaultChartOptions(chartInstanceOptions, {
        chart: { type: 'column' },
    });
}
